export default "__VITE_ASSET__DRIiMgK9__"